<template>
  <section
    id="printstore"
    class="ps-container"
    :class="{ mobile: rootStore.isMobile }"
  >
    <print-store-header></print-store-header>
    <section class="main-container">
      <print-store-sidebar
        class="sidebar-container"
        v-if="!rootStore.isMobile"
      ></print-store-sidebar>
      <router-view class="main-view" :key="$route.path"></router-view>
    </section>
  </section>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import printStoreHeader from '@/features/printstore/children/PrintStoreHeader.vue'
import printStoreSidebar from '@/features/printstore/children/Sidebar.vue'

export default {
  created() {
    if (
      this.$route.name === 'printStore' &&
      !this.rootStore.theme.printStore.isDefault &&
      this.printStoreStore.categories.length
    ) {
      this.$router.push({
        name: 'printStoreCategory',
        params: { categoryId: this.printStoreStore.categories[0].id }
      })
    }
  },
  components: {
    printStoreHeader,
    printStoreSidebar
  },
  head: {
    title:
      'Signing voor professionals | Koninklijke Rijnja - Prints voor professionals'
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    isDashboad() {
      return this.$route.name === 'printStore'
    }
  },
  methods: {
    refreshStore() {
      this.printStoreStore.hydrate()
    }
  }
}
</script>
<style lang="scss" scoped>
.ps-container {
  //top: 20px;
  position: relative;
  max-width: 1240px;
  margin: 0 auto;
  width: calc(100vw - 70px);

  &.mobile {
    background-color: white;
    width: 100vw;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 10;
  }
}

.main-container {
  display: flex;
}
.sidebar-container {
  width: 165px;
  flex-shrink: 0;
  padding-top: 40px;
}
.main-view {
  flex: 1 0;
  padding-top: 15px;
}

.mobile {
  .ps-ad {
    left: auto;
  }
}

@media only screen and (min-width: 620px) {
  .main-view {
    padding-top: 0;
  }

  .sidebar-container {
    padding-top: 12px;
  }

  .ps-container {
    width: calc(100vw - 30px);

    .main-container {
      height: calc(100% - 47px);
    }
  }
}

@media only screen and (min-width: 940px) {
  .ps-container {
    margin-left: 308px;
    padding-left: 25px;
    //top: 110px;
    width: calc(100vw - 326px);
  }
}
</style>
